export const MODULE_DEPENDENCIES = {
    consultancy: ["employee_pp"],
};
